module.exports = __webpack_public_path__ + "1962d1fce5df72e1fc5c483bb2fa9eaa.svg";